<template>
  <div>
    <BaseReportTable
      :resultados="resultados"
      :total-items="totalItems"
      :items-por-pagina="itemsPorPagina"
      :pagina-actual="paginaActual"
      :loading="loading"
      :headers="infoCteYNoCteHeaders"
      :es-operacion="esOperacion"
      @cambiar-pagina="$emit('cambiar-pagina', $event)"
      @cambiar-items-por-pagina="$emit('cambiar-items-por-pagina', $event)"
    >
      <template v-slot:item.legajo="{ item }">
        <a
          v-if="item.legajo"
          :href="getGestionarUrl(item.legajo)"
          target="_blank"
          class="legajo-link"
        >
          {{ item.legajo }}
        </a>
        <template v-else>-</template>
      </template>

      <template v-slot:item.monto_otorgado="{ item }">
        ${{ formatoNumero(item.monto_otorgado || 0) }}
      </template>

      <template v-slot:item.saldo_capital_total="{ item }">
        ${{ formatoNumero(item.saldo_capital_total || 0) }}
      </template>

      <template v-slot:item.capital_corriente="{ item }">
        ${{ formatoNumero(item.capital_corriente || 0) }}
      </template>

      <template v-slot:item.capital_no_corriente="{ item }">
        ${{ formatoNumero(item.capital_no_corriente || 0) }}
      </template>
    </BaseReportTable>
  </div>
</template>

<script>
import BaseReportTable from './BaseReportTable.vue';
import ReportCalculations from '../ReportCalculations';

export default {
  name: 'InfoCteYNoCteReportTable',
  components: {
    BaseReportTable,
  },
  mixins: [ReportCalculations],
  props: {
    resultados: {
      type: Array,
      default: () => [],
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    itemsPorPagina: {
      type: Number,
      default: 10,
    },
    paginaActual: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    esOperacion: {
      type: String,
      default: '',
    },
  },
  computed: {
    infoCteYNoCteHeaders() {
      return [
        { text: 'Legajo', value: 'legajo' },
        {
          text: 'Operatoria / Línea',
          value: 'operatoria_linea',
          width: '200px',
        },
        {
          text: 'Apellido y Nombre / Razón Social',
          value: 'nombre_razon_social',
        },
        { text: 'CUIT', value: 'cuit' },
        { text: 'Departamento', value: 'departamento' },
        { text: 'Persona', value: 'persona' },
        { text: 'Monto del Crédito', value: 'monto_otorgado' },
        { text: 'Saldo Capital Total', value: 'saldo_capital_total' },
        { text: 'Corriente', value: 'capital_corriente' },
        { text: 'No Corriente', value: 'capital_no_corriente' },
      ];
    },
  },
  methods: {
    getGestionarUrl(legajo) {
      const baseUrl = process.env.VUE_APP_GESTIONAR_URL || 'http://localhost:8080';
      return `${baseUrl}/gestionar/${legajo}`;
    },
  },
};
</script>

<style scoped>
.legajo-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.legajo-link:hover {
  color: #1565c0;
  text-decoration: underline;
}
</style>

